import { StructuredJsonFieldDef } from '../../shared/design-system/structured-json-form.model';
import { parseStructuredJsonArray } from '../../shared/design-system/structured-json-form.utils';

export const GROWTH_INDUSTRY_PACK_LIFECYCLE_STATUSES = [
  'Available',
  'Installed',
  'Disabled'
] as const;

export const GROWTH_INDUSTRY_BINDING_ENTITY_TYPES = [
  'Order',
  'Customer',
  'Account',
  'Policy',
  'Room',
  'Guest',
  'Student',
  'Patient',
  'CitizenCase',
  'Subscriber'
] as const;

export const growthIndustryKpiFields: StructuredJsonFieldDef[] = [
  { key: 'key', type: 'string', labelKey: 'growth.industryPacks.detail.kpi.fields.key', required: true },
  { key: 'type', type: 'string', labelKey: 'growth.industryPacks.detail.kpi.fields.type' },
  { key: 'displayName', type: 'string', labelKey: 'growth.industryPacks.detail.kpi.fields.displayName' }
];

export const growthIndustrySegmentFields: StructuredJsonFieldDef[] = [
  { key: 'key', type: 'string', labelKey: 'growth.industryPacks.detail.segments.fields.key', required: true },
  { key: 'displayName', type: 'string', labelKey: 'growth.industryPacks.detail.segments.fields.displayName' }
];

export const growthIndustryPromptFields: StructuredJsonFieldDef[] = [
  { key: 'key', type: 'string', labelKey: 'growth.industryPacks.detail.prompts.fields.key', required: true },
  { key: 'provider', type: 'string', labelKey: 'growth.industryPacks.detail.prompts.fields.provider' }
];

export const growthIndustryPlaybookStepFields: StructuredJsonFieldDef[] = [
  { key: 'stepId', type: 'string', labelKey: 'growth.industryPacks.detail.playbook.fields.stepId', required: true },
  { key: 'action', type: 'string', labelKey: 'growth.industryPacks.detail.playbook.fields.action' },
  { key: 'contentType', type: 'string', labelKey: 'growth.industryPacks.detail.playbook.fields.contentType' },
  { key: 'channel', type: 'string', labelKey: 'growth.industryPacks.detail.playbook.fields.channel' },
  { key: 'day', type: 'number', labelKey: 'growth.industryPacks.detail.playbook.fields.day' }
];

export const growthIndustryCampaignFields: StructuredJsonFieldDef[] = [
  { key: 'key', type: 'string', labelKey: 'growth.industryPacks.detail.campaigns.fields.key', required: true },
  { key: 'channel', type: 'string', labelKey: 'growth.industryPacks.detail.campaigns.fields.channel' },
  { key: 'purpose', type: 'string', labelKey: 'growth.industryPacks.detail.campaigns.fields.purpose' }
];

export const growthIndustryFormRefFields: StructuredJsonFieldDef[] = [
  { key: 'definitionKey', type: 'string', labelKey: 'growth.industryPacks.detail.forms.fields.definitionKey', required: true },
  { key: 'role', type: 'string', labelKey: 'growth.industryPacks.detail.forms.fields.role' }
];

export const growthIndustryComplianceFields: StructuredJsonFieldDef[] = [
  { key: 'rule', type: 'string', labelKey: 'growth.industryPacks.detail.compliance.fields.rule', required: true },
  { key: 'note', type: 'textarea', labelKey: 'growth.industryPacks.detail.compliance.fields.note' }
];

export const growthIndustryBindingMetadataFields: StructuredJsonFieldDef[] = [
  { key: 'source', type: 'string', labelKey: 'growth.industryBindings.detail.metadata.fields.source' },
  { key: 'notes', type: 'textarea', labelKey: 'growth.industryBindings.detail.metadata.fields.notes' }
];

export function emptyIndustryBindingMetadataJson(): string {
  return JSON.stringify({ source: '', notes: '' });
}

export function industryPackArrayPayloads(json: string | null | undefined): string[] {
  return parseStructuredJsonArray(json).map(item => JSON.stringify(item));
}
